import service from '../service/card'
import CONSTANT from '../constant/exchange_record'
import { Indicator } from 'mint-ui';


export default {
  getUserCardList({ commit }) {
    Indicator.open()
    return new Promise((resolve, reject) => {
      return service.getUserCardList().then((res) => {
        resolve(res.list)
        commit(CONSTANT.GET_USER_CARD_LIST_SUCCESS, res.list)
        Indicator.close()
        return res
      }, (e) => {
        reject(e)
        commit(CONSTANT.GET_USER_CARD_LIST_ERROR, e)
        Indicator.close()
      })
    })
  },
  getNewCardBillList({ commit }, params) {
    Indicator.open()
    return new Promise((resolve, reject) => {
      return service.getNewCardBillList(params).then((res) => {
        resolve(res)
        commit(CONSTANT.GET_NEW_CARD_BILL_LIST_SUCCESS, res)
        Indicator.close()
        return res
      }, (e) => {
        reject(e)
        commit(CONSTANT.GET_NEW_CARD_BILL_LIST_ERROR, e)
        Indicator.close()
      })
    })
  }
}